/**
 * Arbe mega menu — desktop hover chrome, plus a resize reset so
 * main1.js fadeToggle cannot leave the nav hidden on desktop.
 * Mobile submenu expand/collapse is CSS :hover / :focus-within.
 */
(function () {
	'use strict';

	function isMobileWidth() {
		return window.innerWidth <= 992;
	}

	function resetForDesktop() {
		var nav = document.querySelector('.header_wrap__nav');
		var overlay = document.querySelector('.overlay');
		if (nav) {
			nav.style.display = '';
			nav.style.opacity = '';
			nav.style.height = '';
		}
		if (overlay) {
			overlay.classList.remove('overlay_active');
		}
	}

	function syncAmmExpanded(activeItem) {
		var desktop = !isMobileWidth();
		document.querySelectorAll('.amm-items .amm-navitem').forEach(function (item) {
			var btn = item.querySelector('button[aria-expanded]');
			if (!btn) {
				return;
			}
			var open = desktop && (
				item === activeItem ||
				item.matches(':hover') ||
				item.classList.contains('amm-open')
			);
			btn.setAttribute('aria-expanded', open ? 'true' : 'false');
		});
	}

	document.addEventListener('DOMContentLoaded', function () {
		var navItemsEls = document.querySelectorAll('.amm-items');
		var headerEl = document.querySelector('header.header');

		if (headerEl) {
			navItemsEls.forEach(function (navItemsEl) {
				navItemsEl.addEventListener('mouseenter', function () {
					if (!isMobileWidth()) {
						headerEl.classList.add('amm-header-active');
					}
				});
				navItemsEl.addEventListener('mouseleave', function () {
					if (!isMobileWidth()) {
						headerEl.classList.remove('amm-header-active');
					}
				});
				navItemsEl.addEventListener('focusin', function () {
					if (!isMobileWidth()) {
						headerEl.classList.add('amm-header-active');
					}
				});
				navItemsEl.addEventListener('focusout', function (e) {
					if (!isMobileWidth() && !navItemsEl.contains(e.relatedTarget)) {
						headerEl.classList.remove('amm-header-active');
					}
				});
			});
		}

		document.querySelectorAll('.amm-items .amm-navitem').forEach(function (item) {
			item.addEventListener('mouseenter', function () {
				syncAmmExpanded(item);
			});
			item.addEventListener('mouseleave', function () {
				syncAmmExpanded(null);
			});
		});

		window.addEventListener('resize', function () {
			if (!isMobileWidth()) {
				resetForDesktop();
			}
			syncAmmExpanded(null);
		});
	});
})();
